// Version : 0.0.1
// Author : Vignesh
import { docodeHexResponse } from '../../../_common/common.utils';
import IndividualLoanActionTypes from './individual-loan-proposal.types';

const INITIAL_STATE = {
	addIndividualProposalResponse: null,
	updateIndividualProposalResponse: null,
};

const individualLoanProposalReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** ADD INDIVIDUAL LOAN PROPOSAL START ***************** */
		case IndividualLoanActionTypes.ADD_INDIVIDUAL_LOAN_PROPOSAL_SUCCESS:
			return { ...state, addIndividualProposalResponse: action.payload };

		case IndividualLoanActionTypes.ADD_INDIVIDUAL_LOAN_PROPOSAL_FAILURE:
			return { ...state, addIndividualProposalResponse: action.payload };

		case IndividualLoanActionTypes.ADD_INDIVIDUAL_LOAN_PROPOSAL_RESPONSE_CHANGED:
			return { ...state, addIndividualProposalResponse: null };
		/** ***************** ADD INDIVIDUAL LOAN PROPOSAL END ***************** */

		/** ***************** UPDATE INDIVIDUAL LOAN PROPOSAL START ***************** */
		case IndividualLoanActionTypes.UPDATE_INDIVIDUAL_LOAN_PROPOSAL_SUCCESS:
			return { ...state, updateIndividualProposalResponse: action.payload };

		case IndividualLoanActionTypes.UPDATE_INDIVIDUAL_LOAN_PROPOSAL_FAILURE:
			return { ...state, updateIndividualProposalResponse: action.payload };

		case IndividualLoanActionTypes.UPDATE_INDIVIDUAL_LOAN_PROPOSAL_RESPONSE_CHANGED:
			return { ...state, updateIndividualProposalResponse: null };
		/** ***************** UPDATE INDIVIDUAL LOAN PROPOSAL END ***************** */

		/** ***************** SEARCH MEMBER LOAN PROPOSAL START ***************** */
		// Searched Member List Response
		case IndividualLoanActionTypes.SEARCH_MEMBER_LOAN_PROPOSAL_SUCCESS:
			return {
				...state,
				searchMemberLoanProposalResponse: action.payload,
				searchMemberLoanProposalListArr: docodeHexResponse(
					action.payload,
					'getSearchMemberDetailsForPersonalLoanKey',
				),
			};

		case IndividualLoanActionTypes.SEARCH_MEMBER_LOAN_PROPOSAL_FAILURE:
			return { ...state, searchMemberLoanProposalResponse: action.payload };

		case IndividualLoanActionTypes.SEARCH_MEMBER_LOAN_PROPOSAL_RESPONSE_CHANGED:
			return { ...state, searchMemberLoanProposalResponse: null };

		/** ***************** SEARCH MEMBER LOAN PROPOSAL END ***************** */
		default:
			return state;
	}
};

export default individualLoanProposalReducer;
